/**
 * HowItWorksCard - Card with green Dasher logo and play button
 * Used on the welcome screen to link to tutorial/explainer content
 */

import { useState } from "react";
import { VideoModal } from "@/components/VideoModal";

const HOW_IT_WORKS_VIDEO_ID = "6sygIKvdtzM";

interface HowItWorksCardProps {
  onClick?: () => void;
}

export function HowItWorksCard({ onClick }: HowItWorksCardProps) {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const handleClick = () => {
    setIsVideoOpen(true);
    onClick?.();
  };

  return (
    <>
    <div className="flex flex-col gap-3 px-6 pb-8">
      {/* Section Title */}
      <h3 className="text-white text-xl font-semibold font-dm-sans">
        Curious how Dasher works?
      </h3>

      {/* Card */}
      <button
        onClick={handleClick}
        className="relative flex items-center w-full h-[68px] bg-[#0f2217] rounded-xl overflow-hidden hover:bg-[#132b1c] transition-all"
      >
        {/* Dasher Logo - Positioned to overflow at left edge */}
        <div className="absolute -left-8 top-1/2 -translate-y-1/2 w-32 h-32">
          <img
            src="/Dasher.png"
            alt="Dasher"
            className="w-full h-full object-contain drop-shadow-lg"
          />
        </div>

        {/* Text Content */}
        <div className="flex-1 ml-24 text-left">
          <p className="text-white text-[15px] font-normal font-dm-sans leading-tight">
            Learn how to turn
            <br />
            consistency into cash
          </p>
        </div>

        {/* Play Button */}
        <div className="flex items-center justify-center mr-4">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 3C15.0333 3 12.1332 3.87973 9.66645 5.52796C7.19972 7.17618 5.27713 9.51886 4.14181 12.2597C3.0065 15.0006 2.70945 18.0166 3.28823 20.9264C3.86701 23.8361 5.29562 26.5088 7.3934 28.6066C9.49119 30.7044 12.1639 32.133 15.0737 32.7118C17.9834 33.2906 20.9994 32.9935 23.7403 31.8582C26.4812 30.7229 28.8238 28.8003 30.472 26.3336C32.1203 23.8668 33 20.9667 33 18C33 16.0302 32.612 14.0796 31.8582 12.2597C31.1044 10.4399 29.9995 8.78628 28.6066 7.3934C27.2137 6.00052 25.5601 4.89563 23.7403 4.14181C21.9204 3.38799 19.9698 3 18 3ZM15 24.75V11.25L24 18L15 24.75Z" fill="#81F680"/>
          </svg>
        </div>
      </button>
    </div>

    <VideoModal
      isOpen={isVideoOpen}
      onClose={() => setIsVideoOpen(false)}
      videoId={HOW_IT_WORKS_VIDEO_ID}
      title="How Dasher Works"
    />
    </>
  );
}
